import { render, staticRenderFns } from "./AdminSearchAndListBridges.vue?vue&type=template&id=060a2742&scoped=true&"
import script from "./AdminSearchAndListBridges.vue?vue&type=script&lang=js&"
export * from "./AdminSearchAndListBridges.vue?vue&type=script&lang=js&"
import style0 from "./AdminSearchAndListBridges.vue?vue&type=style&index=0&id=060a2742&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060a2742",
  null
  
)

export default component.exports